import { ReportViewProps } from '@pages/app/rca/tabs/reports/views/report-view-props';

export default function UnknownReportView(_: ReportViewProps) {
  return (
    <div>
      <h1>Unknown Report Type</h1>
    </div>
  );
}
